<template>
  <div class="system-header">
    <div class="left-box">
      <div class="platform-info">
        <img class="logo" :src="systemInfo.systemLogo ?  systemInfo.systemLogo : defaultAvatar" alt=""/>
        <span class="platform-name">{{systemInfo.systemName}}</span>
      </div>

      <TopMenu></TopMenu>
    </div>
    <div class="right-box flex-center-center">
      <!-- 用户头像 -->
      <div class="user-avatar">
        <img :src="newUserInfo.headImg ?  newUserInfo.headImg : defaultAvatar" alt=""/>
      </div>
      <!-- 用户信息 -->
      <div class="user-info">
        <el-dropdown>
            <span class="el-dropdown-link">
              欢迎您，{{ newUserInfo.name || '' }}
               <el-icon class="user-info-icon" :size="20"><ArrowDown/></el-icon>
            </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item @click="changeAvatar">更换头像</el-dropdown-item>
              <el-dropdown-item @click="loginOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
  <Password v-model:visible="showAddDialog"></Password>
  <!-- 更换头像 -->
  <el-dialog
      v-model="dialogVisible"
      title="更换头像"
      width="600px"
  >
    <div class="avatar-main">
      <UploadImg v-model:value="newAvatar"></UploadImg>
    </div>
    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleUpdateAvatar">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from 'vue';
import {useStore} from 'vuex';
import TopMenu from '../Menu/topMenu.vue';
import Password from './password.vue';
import {ArrowDown} from "@element-plus/icons-vue";
import UploadImg from "@/components/uploadImg/index.vue";
import defaultAvatar from '@/assets/images/avatar.gif'
import {getLogoInfo, updateHeadImg} from "@/api/apiUser";
import {ElMessage} from "element-plus";
import {getSystemInfo} from "@/api/apiSystem";
import emitter from "@/utils/eventBus";

const store = useStore();
const userInfo=store.getters['user/userInfo']
const showAddDialog = ref(false)
const dialogVisible = ref(false)
const newAvatar=ref('')
const systemInfo=ref({})
const newUserInfo=ref({})
const loginOut = () => {
  store.dispatch('user/loginOut');
}
//修改密码
const changePassword = () => {
  showAddDialog.value = true
}
//修改头像
const changeAvatar=()=> {
  newAvatar.value=newUserInfo.value.headImg
  dialogVisible.value=true
}
//修改头像
const handleUpdateAvatar=async ()=> {
  if (!newAvatar.value) return ElMessage.warning('请上传头像！');
  const {code} = await updateHeadImg({headImg:newAvatar.value})
  if (code === 200) {
    await queryUserInfo()
    ElMessage.success('修改成功！');
    dialogVisible.value=false
  }
}
const querySystemInfo=async ()=>{
  const {code,data}=await getSystemInfo();
  if(code===200){
    systemInfo.value=data
  }
}
const queryUserInfo=async ()=>{
  const {code,data}=await getLogoInfo()
  if(code===200){
    newUserInfo.value=data
  }
}
querySystemInfo()
queryUserInfo()
onMounted(() => {
  emitter.on('againGetSystemInfo',querySystemInfo)
  emitter.on('againGetLogoInfo',queryUserInfo)
})
onBeforeUnmount(() => {
  emitter.off('againGetSystemInfo')
  emitter.off('againGetLogoInfo')
})
</script>
<style>
.el-dropdown:focus,
.el-dropdown:focus-visible,
.el-dropdown:focus-visible {
  outline: none !important; /* 移除轮廓 */
}
.el-dropdown{
  outline: none !important;
}
.el-dropdown *:focus {
  outline: none !important;
}
</style>
<style lang="scss" scoped>
.system-header {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 20px;
  overflow: hidden;
  background-color: #0286df;
  color: #fff;
}

.left-box {
  display: flex;
  align-items: center;
  width: 70%;
  .platform-info {
    display: flex;
    align-items: center;
    margin-right: 40px;

    .logo {
      height: 40px;
    }

    .platform-name {
      margin-left: 10px;
      font-size: 20px;
      font-weight: bold;
    }
  }

}

.flex-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-box {
  .user-avatar {
    width: 40px;
    height: 40px;
    background: #fafafa;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 50%;

    img {
      width: 100%;
      border-radius: 50%;
    }
  }

  .user-info {
    margin-left: 16px;
    cursor: pointer;
    border: none !important;
    .el-dropdown-link {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #fff;
      font-weight: 500;

      .user-info-icon {
        margin-left: 10px;
      }
    }
  }
}

.head-fold {
  font-size: 20px;
}
</style>
